interface LogoProps {
  className?: string;
}

export function ECommerceFundLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M20.5,15.3c0-.7.5-1.3,1.1-1.5.2,0,.4-.1.6-.1h4.8c.2,0,.4,0,.5.1.6.2,1.1.8,1.1,1.5v8.2h-8v-8.2h0ZM17.6,46h19.7l-19.7-1.5c-1.6,0-2.7-1.6-2.7-3.1V8.6c0-1.5,1.1-3,2.7-3h14.4c1.6,0,2.6,1.5,2.6,3v24.6c0,1.5-1,3-2.5,3.1h-9.9c-.2,0-.4,0-.6,0-.6-.2-1.1-.8-1.1-1.4v-9.7h10.1v-9.7c0-1.7-1.4-3.1-3.2-3.1h-5.9c-1.7,0-3.2,1.4-3.2,3.1v19.4c0,1.7,1.4,3,3.2,3h10.5c2.6,0,4.7-2.1,4.7-4.6V8.6c0-2.5-2.1-4.6-4.8-4.6h-14.4c-2.6,0-4.8,2-4.8,4.6v32.7c0,2.5,2.2,4.6,4.8,4.6" 
      />
    </svg>
  );
}